(() => {
  if (window.BeautyFashionCartEnhancementsReady) return;
  window.BeautyFashionCartEnhancementsReady = true;

  const root = window.Shopify?.routes?.root || '/';
  const announce = (message) => {
    const region = document.querySelector('.bf-live-region');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => { region.textContent = message; }, 30);
  };
  const setStepperState = (input) => {
    const decrease = input.closest('[data-quantity-stepper]')?.querySelector('[data-quantity-step="-1"]');
    if (decrease) decrease.disabled = Number(input.value) <= Number(input.min || 1);
  };
  const parseSection = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  const refreshDrawer = async (open, itemCount) => {
    const shouldOpen = open ?? window.BeautyFashionCartUI.isDrawerOpen();
    const drawerSection = document.querySelector('#CartDrawerSection')?.closest('.shopify-section');
    const headerSection = document.querySelector('.site-header')?.closest('.shopify-section');
    const drawerSectionId = drawerSection?.id.replace('shopify-section-', '');
    const headerSectionId = headerSection?.id.replace('shopify-section-', '');
    const sectionIds = [drawerSectionId, headerSectionId].filter(Boolean);
    if (!sectionIds.length) return;
    const response = await fetch(`${root}cart?sections=${sectionIds.join(',')}`);
    const sections = await response.json();
    if (drawerSectionId && sections[drawerSectionId]) {
      const next = parseSection(sections[drawerSectionId], '#CartDrawerSection');
      const current = document.querySelector('#CartDrawerSection');
      if (next && current) current.replaceWith(next);
    }
    const count = parseSection(headerSectionId ? sections[headerSectionId] || '' : '', '[data-cart-count]');
    const nextItemCount = Number.isInteger(itemCount) ? itemCount : Number.parseInt(count?.textContent, 10);
    if (!Number.isNaN(nextItemCount)) window.BeautyFashionCartUI.setCount(nextItemCount);
    window.BeautyFashionCartUI.setDrawerOpen(shouldOpen, { restoreFocus: false });
  };
  const giftConfig = () => {
    const section = document.querySelector('#CartDrawerSection');
    return {
      enabled: section?.dataset.autoGiftEnabled === 'true',
      variantId: Number(section?.dataset.autoGiftVariantId || 0),
      threshold: Number(section?.dataset.autoGiftThreshold || 0),
      error: section?.dataset.autoGiftError || 'The selected gift could not be made free.'
    };
  };
  const isGiftLine = (item) => String(item.properties?._bf_free_necklace) === 'true';
  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read cart.');
    return response.json();
  };
  const removeGiftLines = async (items) => {
    let itemCount;
    for (const item of items) {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
      if (!response.ok) throw new Error('Unable to remove necklace gift.');
      const data = await response.json();
      if (Number.isInteger(data.item_count)) itemCount = data.item_count;
    }
    return itemCount;
  };
  let giftSyncing = false;
  let giftSyncTimer = 0;
  const syncAutomaticGift = async () => {
    if (giftSyncing) return;
    giftSyncing = true;
    let cartChanged = false;
    let itemCount;
    try {
      const config = giftConfig();
      const cart = await fetchCart();
      const giftLines = cart.items.filter(isGiftLine);
      const qualifyingTotal = cart.items.filter((item) => !isGiftLine(item)).reduce((total, item) => total + item.final_line_price, 0);
      const matchingGift = giftLines.find((item) => Number(item.variant_id) === config.variantId);
      const paidMatchingGift = matchingGift?.final_line_price > 0 ? matchingGift : null;
      const validMatchingGift = matchingGift && !paidMatchingGift ? matchingGift : null;
      const giftShouldExist = config.enabled && config.variantId > 0 && qualifyingTotal >= config.threshold;
      const wrongGiftLines = giftLines.filter((item) => !giftShouldExist || Number(item.variant_id) !== config.variantId || item !== validMatchingGift);

      if (wrongGiftLines.length) {
        itemCount = await removeGiftLines(wrongGiftLines);
        cartChanged = true;
      }

      const failureKey = `bf-gift-discount-failed:${config.variantId}:${config.threshold}`;
      if (paidMatchingGift) {
        sessionStorage.setItem(failureKey, 'true');
        announce(config.error);
      }

      if (giftShouldExist && !validMatchingGift && !paidMatchingGift) {
        if (sessionStorage.getItem(failureKey) !== 'true') {
          const addResponse = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: config.variantId, quantity: 1, properties: { _bf_free_necklace: 'true' } }] })
          });
          const addData = await addResponse.json();
          if (!addResponse.ok) throw new Error(addData.description || 'Unable to add necklace gift.');
          if (Number.isInteger(addData.item_count)) itemCount = addData.item_count;
          const verifiedCart = await fetchCart();
          if (Number.isInteger(verifiedCart.item_count)) itemCount = verifiedCart.item_count;
          const verifiedGift = verifiedCart.items.find((item) => isGiftLine(item) && Number(item.variant_id) === config.variantId);
          if (!verifiedGift || verifiedGift.final_line_price > 0) {
            if (verifiedGift) itemCount = await removeGiftLines([verifiedGift]);
            sessionStorage.setItem(failureKey, 'true');
            announce(config.error);
          } else {
            cartChanged = true;
            announce('Free necklace added to cart');
          }
        }
      }

      if (validMatchingGift && validMatchingGift.quantity !== 1) {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: validMatchingGift.key, quantity: 1 })
        });
        if (!response.ok) throw new Error('Unable to update necklace gift.');
        const data = await response.json();
        if (Number.isInteger(data.item_count)) itemCount = data.item_count;
        cartChanged = true;
      }

      if (cartChanged) {
        if (document.querySelector('.cart-page')) window.location.reload();
        else await refreshDrawer(document.getElementById('CartDrawer')?.getAttribute('aria-hidden') === 'false', itemCount);
      }
    } catch (error) {
      announce(error.message);
    } finally {
      giftSyncing = false;
    }
  };
  const scheduleGiftSync = () => {
    window.clearTimeout(giftSyncTimer);
    giftSyncTimer = window.setTimeout(syncAutomaticGift, 120);
  };
  const updateDrawerLine = async (input) => {
    const buttons = input.closest('[data-quantity-stepper]')?.querySelectorAll('button') || [];
    buttons.forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.dataset.quantityKey, quantity: Number(input.value) })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to update cart.');
      await refreshDrawer(true, data.item_count);
      announce('Cart updated');
      scheduleGiftSync();
    } catch (error) {
      announce(error.message);
      buttons.forEach((button) => { button.disabled = false; });
      setStepperState(input);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const input = button.closest('[data-quantity-stepper]')?.querySelector('input');
    if (!input) return;
    const minimum = Number(input.min || 1);
    const nextValue = Math.max(minimum, Number(input.value || minimum) + Number(button.dataset.quantityStep));
    if (nextValue === Number(input.value)) return;
    input.value = nextValue;
    setStepperState(input);
    if (input.dataset.quantityKey) updateDrawerLine(input);
    else input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-quantity-stepper] input');
    if (!input) return;
    input.value = Math.max(Number(input.min || 1), Number(input.value || input.min || 1));
    setStepperState(input);
    if (input.dataset.quantityKey) updateDrawerLine(input);
  });
  new MutationObserver((records) => {
    const drawerChanged = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node instanceof Element && (node.id === 'CartDrawerSection' || node.querySelector?.('#CartDrawerSection'))));
    if (drawerChanged) scheduleGiftSync();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => {
    const config = giftConfig();
    sessionStorage.removeItem(`bf-gift-discount-failed:${config.variantId}:${config.threshold}`);
    scheduleGiftSync();
  });
  scheduleGiftSync();
})();
